import { entityEffects, selectCurrentEntity, selectEntityDisplayName } from '@opengov/app-core/entity';
import { coreFeatureFlagEffects } from '@opengov/app-core/featureFlag';
import { ensureAll } from '@opengov/compose-app-router/onEnter';
import { routerActions } from '@opengov/compose-app-router/state';
import { createSelector } from '@opengov/compose-app/reselect';
import { IEntity } from '@opengov/og-api-ts';
import { generatePageTitle } from '@opengov/stories-shared/utils';

import { onEnterStoriesRoutes } from '../../routes/onEnter';
import { maintenancePath, storyListPath } from '../../routes/paths';
import { StoryView } from '../components';
import { selectStoryViewProps } from '../selectors';

export const storyViewRoute = {
  name: 'StoryView',
  title: createSelector(selectEntityDisplayName, (name) => generatePageTitle('Story', name)),
  selector: selectStoryViewProps,
  component: StoryView,
  onEnter: ensureAll([
    onEnterStoriesRoutes,
    async (
      state,
      nextLocation: { params: { entitySubdomain: string; publicationId: string; storyId: string }; pathname: string },
      onSuccess,
      onError
    ) => {
      const { entitySubdomain } = nextLocation.params;
      await entityEffects
        .fetchRequestedOrCurrentEntity({
          requestedEntitySubdomain: entitySubdomain,
          currentEntity: selectCurrentEntity(state)
        })
        .then(async (entity: IEntity) => {
          if (entity.subdomain !== entitySubdomain) {
            return onError(
              'Entity not found...',
              routerActions.replace.create({ pathname: storyListPath(entity.subdomain) })
            );
          }

          await coreFeatureFlagEffects.getFlags().then(async (flags) => {
            if (flags && flags['product-stories-maintenance-window']) {
              return onError(
                'Redirecting to maintenance page...',
                routerActions.replace.create({ pathname: maintenancePath(entitySubdomain) })
              );
            }

            onSuccess();
          });
        });
    }
  ])
};
